
// CONTENT.JS
//
// This File contains the contents of the website!
// Changes in this file only take effect, after: npm run build
//
// The website content is specified as a javascript object literal below.
// The "content"-fields, below can be an object or an array of objects. Content objects can be nested.
//
// Hint: Use ` ` for multi-line strings. (This is what requires the build step - as it is not supported by all browsers)
//
// Supported Objects in content fields:
//
// // Simple HTML:
// 	{
//		type: "html"
//		value: "<p>some html<p>"
// 	}
// // Expandable: Allows to show/hide content by clicking on title
// 	{
// 		type: "expandable",
// 		title: "The Title",
// 		content: []
// 	}
// // Cards: Allows to display content in cards
// 	{
// 		type: "cards", // use "cards-light" for dark background
// 		cards:
// 		[
// 			{
// 				card: "1",
// 				content: []
// 			},
// 			{
// 				card: "2",
// 				content: []
// 			},
// 		]
// 	}
// // Table:
// 	{
// 		type: "table",
// 		widths: ['4em','auto','auto','auto'], // column widths
// 		// rowStyle: ["font-weight: bold;font-size: 1.2em", "font-weight: bold; background-color: #2B628D; color: white","font-size: 0.9em;","font-size: 0.9em;","font-size: 0.9em;","font-size: 0.9em;","font-size: 0.9em;"],
// 		// colStyle: ["font-weight: bold"],
// 		// cellStyle: "",

// 		// rowClass: [],
// 		// colClass: [],
// 		// cellClass: "",

// 		table: [
// 			["cell11","cell12","cell13","cell14"], // row 1
// 			["cell21","cell22","cell23","cell24"], // row 2
// 		]
// }
// Components:
// 	{
// 		type: "component:co-sponsors" / "component:sponsors" / "component:speakers" / "component:organizers"
// 	}


// Styles AND Classes:
// Except for Components (i.e., type: "component:..."). All content objects support fields "class" & "style" to add specific classes and styles to the contents.

// Timing:
// Every content object or property (simple properties can be made objects as {value: string})
// can have "from" and / or "till" properties that specify when they are to be displayed.
// If there are multiple choices depending on the date. Arrays of {value: x, from:y, till:z} are possible. The first match will be displayed.
// Time Format is: 2020-09-29T14:23:00 // all time must be specified in CEST = UTC+2
// Examples:
// header:{
//	 message: [{value: "Register Now", till:"2020-09-29T08:00"},{value: "Ongoing",from:"2020-09-29T08:00"}]
// }
//

// Icons: https://fontawesome.com/v5.3.1/icons?d=gallery


const cfp = `
	<p>As the standardization of 5G is being solidified, researchers are speculating what 6G will be. Integrating sensing functionality is emerging as a key feature of the 6G Radio Access Network (RAN), allowing to exploit the dense cell infrastructure of 5G for constructing a joint communication and sensing (JC&amp;S) network. As such, the future cellular network could image and measure the surrounding environment to enable advanced environment and location-aware services, ranging from PHY to application layers. While positioning is already implemented in 4G and 5G standards, it is anticipated that JC&amp;S will be at the heart of 6G and beyond systems. New developments are expected to increase communications and sensing performances relying, among others, on wider bandwidths, more antennas, and higher carrier frequencies. Advances in theoretical understanding of the performance and limitations, and new algorithmic solutions, including those based on machine learning, are needed to make that vision come true.</p>
	<p>Despite having drawn huge attention from both academia and industry, many open problems remain to be investigated in JC&amp;S. This symposium aims at bringing together researchers from academia and industry to identify and discuss major technical challenges, recent breakthroughs, and novel applications related to JC&amp;S. Topics include but are not limited to:</p>
	<ul style="font-size: 1.4em;text-align: left; margin: 1em 1.5em;">
		<li>Fundamental information theoretical limits for JC&amp;S</li>
		<li>Network architecture / transmission protocols / frame designs for JC&amp;S</li>
		<li>Spectrum analysis and management of JC&amp;S</li>
		<li>Full duplex / interference management techniques of JC&amp;S</li>
		<li>Precoding / waveform / modulation / receiver design for JC&amp;S</li>
		<li>Security and privacy issues for JC&amp;S</li>
		<li>Machine learning / Network Intelligence for JC&amp;S</li>
		<li>MIMO / Massive MIMO / intelligent reflecting surfaces (IRS) for JC&amp;S</li>
		<li>Fine range Doppler and angle estimation in wireless networks</li>
		<li>SLAM in wireless networks</li>
		<li>Millimeter wave / THz technologies for JC&amp;S</li>
		<li>JC&amp;S for highly mobile networks</li>
		<li>Chirp-based communication and sensing</li>
		<li>Hardware reuse and sharing for JC&amp;S</li>
		<li>Integrated circuits and systems for JC&amp;S</li>
		<li>Hardware architectures for JC&amp;S</li>
		<li>Standardization progress of JC&amp;S</li>
		<li>Wi-Fi sensing / positioning / detection for JC&amp;S</li>
		<li>Experimental demonstrations and prototypes</li>
	</ul>
	<p>Papers outside the areas listed above but related to the focus of the symposium (Joint Communications and Sensing) are also welcome. Manuscripts not exceeding 6 pages must be submitted through <a href="https://edas.info/N28920" target="_blank">EDAS</a>. Extended abstracts from 2 to 3 pages can also be submitted. Submissions should be formatted according to the IEEE conference template. Manuscripts will be peer-reviewed according to the standard IEEE process. All accepted (and presented) papers will be published in the symposium proceedings and will be available on <i>IEEE Xplore</i>.</p>
	<p><a style="font-size: 1.2em" href="JCnS-CfP-2.pdf"><i class="fa fa-file-pdf" style="display: inline-block; margin-right: 0.3em"></i> Download CfP</a></p>
`

export var content = {
	copyrightText: "© Barkhausen Institut - ",
	menu:[

		{text: "Home", target: "page-top"},
		{text: "Speakers", target: "speakers"},
		{text: "Program", target: "program"},
		{text: "Venue", target: "venue"},
		{text: "Authors", target: "authors", till: "2022-03-07T08:00:00" },
		{text: "Registration", target: "registration", till: "2022-03-10T17:30:00" },
		{text: "Committee", target: "committee"},

	],
	header: {
		preTitle: "2nd <strong>IEEE</strong>",
		title: '<span style="font-weight: normal">International</span> Hybrid Symposium <span style="font-weight: normal">on</span><br>Joint Communications & Sensing',
		dates: "March 9 - 10, 2022 <br>In Seefeld (Tirol), Austria & Streaming Worldwide",
		message: [
			{ value: "Registration still available!", till: "2022-03-08T23:50:00" },
			{ value: "Starting Soon!", from: "2022-03-08T23:50:00", till: "2022-03-09T08:30:00" },
			{ value: "Join Now!", from: "2022-03-09T08:30:00", till: "2022-03-09T17:30:00" },
			{ value: "We'll be back @ 9:00 on March 10!", from: "2022-03-09T17:30:00", till: "2022-03-10T08:30:00" },
			{ value: "Join Now!", from: "2022-03-10T08:30:00", till: "2022-03-10T18:15:00" },
			{ value: "Rewatch the event now!", from: "2022-03-10T18:15:00" }
		],
		buttons: [

			{
				text: "Register Now",
				till: "2022-03-10T17:30:00",
				icon: "fa fa-play",
				target: "#registration"
			},
			// {
			//  	text: "Become a Sponsor",
			// 		icon: "fa fa-file-pdf",
			//  	till: "2021-02-23T08:00:00",
			//  	target: "2021_Patronage_Brochure.pdf"
			// },
			{
				text: "Rewatch",
				icon: "fas fa-film", // FA Icon
				target: "#program"
			},
			{
			 	text: "Stay Tuned",
			 	icon: "fab fa-twitter", // FA Icon
			 	target: "https://twitter.com/5g_lab"
			},
			{
				text: "Add to Calendar",
				icon: "far fa-calendar-alt",
				till: "2022-03-08T22:00:00",
				target: "jcns-2022.ics"
			},
			{
				text: "5G++ Summit",
				icon: "fa fa-star", // FA Icon
				target: "http://5gsummit.org/dresden/"
		   	},

			{
				text: "Video Guidlines",
				icon: "fa fa-video",
				till: "2022-02-20T10:00:00",
				target: "/video-guidelines"
			},
			{
				text: "JC&S 2021",
				icon: "fas fa-history", // FA Icon
				target: "/legacy/2021"
			},



		]
	},
	sections: [
		{
			name: "about",
			background: "light",
			content: [
				{
					type: "html",
					from: "2022-03-09T08:30:00",
					value: `
						<div style="font-size: 1.2em; border: 3px solid #53668A;">
						<i class='fas fa-film' style="font-size: 200%; margin-top: .4em;"></i>
						<p><strong>You can find the conference's recordings in the <a href="#program">Program section</a>.</strong><br>Participants of the conference have been provided the password by email.</p>
						</div>
					`
				},
				{
					type: "html",
					till: "2022-03-09T08:30:00",
					value: `
						<div style="font-size: 1.2em">
						<p><strong>We'll be live in</strong></p>
						<p><countdown to="2022-03-09T09:00:00"></countdown>.</p>
						</div>
					`
				},

				{
					type: "html",
					from: "2022-03-09T08:30:00",
					till: "2022-03-09T17:30:00",
					value: `
						<div style="font-size: 1.2em">
						<p><strong> >> <a href="https://hopin.com/events/2nd-ieee-international-hybrid-symposium-on-joint-communications-sensing">Watch the live stream!</a> <<</strong>
						<br> (via Hopin - <a href="#registration">registration required</a>)</p>
						</div>
					`
				},

				{
					type: "html",
					from: "2022-03-09T17:30:00",
					till: "2022-03-10T08:30:00",
					value: `
					<div style="font-size: 1.2em">
					<strong><p><a href="#registration">Register NOW</a> for day 2!</p></strong>
					<p style="margin-top: 2em"><strong>The event continues in</strong></p>
						<p><countdown to="2022-03-10T09:00:00"></countdown>.<p>
					</div>
					`
				},

				{
					type: "html",
					from: "2022-03-10T08:30:00",
					till: "2022-03-10T17:30:00",
					value: `
						<div style="font-size: 1.2em">
						<p><strong> >> <a href="https://hopin.com/events/2nd-ieee-international-hybrid-symposium-on-joint-communications-sensing">Watch the live stream!</a> <<</strong>
						<br> (via Hopin - <a href="#registration">registration required</a>)</p>
						</div>
					`
				},
				{
					type: "html",
					value: `<p>The integration of communication and radio sensing in the same spectrum is likely to be one of
							the key features in B5G wireless systems. A joint design of both services will improve the efficiency of
							spectrum usage, and will offer the opportunity of providing radar as a service, just like communications today.
							Recent advances in mmWave communications, massive MIMO and machine learning, among others, are making this
							vision possible, but many technical challenges still remain, from hardware up to the application layer.
							Therefore, Joint Communications and Sensing (JC&S) is the subject of rapidly growing interest in the research
							community, and this symposium will focus on the different system and implementation aspects of this promising
							new approach, bringing together academic and industrial experts from both the radar and communications
							research communities.</p>

							<p>After being virtual-only in 2021, <strong>we return in 2022 with a hybrid event</strong>, allowing <strong>in-person</strong> exchange for those who are able to attend <strong>in lovely Seefeld in Tirol, Austria</strong>. For those unable to attend, <strong>all sessions will also be streamed online</strong>.</p>
							`
				},

				{
					type: "html",
					value: "<cosponsors></cosponsors>",
				},
				{
					type: "html",
					value: `

						<sponsors json="data/sponsors.json" pictures="data/sponsors/" :exclude="['Exhibition']"></sponsors>
						`
				},
				{
					type: "html",
					value: `
					<p style="margin-top: 5em;">Interested in becoming a sponsor?<br>Check out our <a href="IEEE_JCnS_Symposium_2022_Patronage_Brochure.pdf">Patronage Opportunities</a>.</p>
					`
					// <br> Check out our <a href="2021_Patronage_Brochure.pdf">Patronage Brochure <i class="fa fa-file-pdf"></i></a>.</p>
				},



			],
		},
		{
			name: "speakers",
			title: "Speakers & Panelists",
			background: "dark",
			content: [
				{
					type: "component:speakers"
				}
			]
		},




		{
			name: "program",
			title: "Program",
			background: "light",
			content: [
				{
						type:"html",
						value:`
						<h3>Display Times</h3>
						<div>
							<p v-if="!l.showLocalTimes">All times below are Central European Time (CET).</p>
							<p v-if="l.showLocalTimes">All times below are converted to your device's time zone.</p>
						</div>
						<div style="margin-bottom: 3em;"><label class="check-label"><input type="checkbox" v-model="l.showLocalTimes">Show my local times</label></div>

						<h2>Wednesday, March 9</h2>
						`
				},

				{
						type: "table",
						widths: ['20rem','auto'],

						// style: "",
						class: "schedule",
						id: "tblschedule",

						rowStyle: [
									"font-size: 1.3em; font-weight: bold; background-color: #8c7f9c8a; border-bottom: 1px solid gray;",
									"font-size: 1.2em; border-bottom: 1px solid rgb(193 185 201); padding-bottom: 0.3em;",
									"font-size: 1.2em; border-bottom: 1px solid rgb(193 185 201); padding-bottom: 0.3em;",
									"font-size: 1.2em; border-bottom: 1px solid rgb(193 185 201); padding-bottom: 0.3em;",
									"font-size: 1.2em; border-bottom: 1px solid rgb(193 185 201); padding-bottom: 0.3em;",
									"font-size: 1.2em; border-bottom: 1px solid rgb(193 185 201); padding-bottom: 0.3em;",
									"font-size: 1.2em; border-bottom: 1px solid rgb(193 185 201); padding-bottom: 0.3em;",
									"font-size: 1.2em; border-bottom: 1px solid rgb(193 185 201); padding-bottom: 0.3em;",
									"font-size: 1.2em; border-bottom: 1px solid rgb(193 185 201); padding-bottom: 0.3em;",
									"font-size: 1.2em; border-bottom: 1px solid rgb(193 185 201); padding-bottom: 0.3em;",
									"font-size: 1.2em; border-bottom: 1px solid rgb(193 185 201); padding-bottom: 0.3em;",
									"font-size: 1.2em; border-bottom: 1px solid rgb(193 185 201); padding-bottom: 0.3em;",
									"font-size: 1.2em; border-bottom: 1px solid rgb(193 185 201); padding-bottom: 0.3em;",
									"font-size: 1.2em; padding-bottom: 0.3em;",
								],
						colStyle: ["font-weight: bold;","text-align: left;"	],
						cellStyle: "",

						// rowClass: [],
						// colClass: [],
						// cellClass: "",

						table: [
							[	`Day 1<span v-show="!l.showLocalTimes"> (CET)</span>`,"Single Track"],
							[ 	`{{time("2022-03-09T08:30:00","8:30")}}<br v-if="l.showLocalTimes"> - <br v-if="l.showLocalTimes">{{time("2022-03-09T09:00:00","9:00")}}`,
								`<strong>Morning Coffee & Snacks</strong>
										<videomodal ref="videomodal"></videomodal>
								`, ],
							[ 	`{{time("2022-03-09T09:00:00","9:00")}}<br v-if="l.showLocalTimes"> - <br v-if="l.showLocalTimes">{{time("2022-03-09T09:10:00","9:10")}}
									<br><button style="margin: 0.5em" class="btn btn-general" @click="$refs['videomodal'].openModal({title:'Conference Opening & Welcome Speech',time:'2022-03-09T09:00:00', vimeo: '690402660?h=8a6fdbf641'  })"><i class="fa fa-film"></i> Rewatch</button>
							`,
								`<strong>Conference Opening & Welcome Speech</strong>
								`, ],
							[ 	`{{time("2022-03-09T09:10:00","9:10")}}<br v-if="l.showLocalTimes"> - <br v-if="l.showLocalTimes">{{time("2022-03-09T10:35:00","10:35")}}
									<br><button style="margin: 0.5em" class="btn btn-general" @click="$refs['videomodal'].openModal({title:'Paper Session I: Theoretical Bounds and Optimization',time:'2022-03-09T09:10:00',name:'', affiliation: '', vimeo: '690403495?h=e12acc8541'  })"><i class="fa fa-film"></i> Rewatch</button>
								`,
								`<strong>Paper Session I: Theoretical Bounds and Optimization (virtual session)</strong>
									<div style="display: flex; margin-top: 0.3em;">
											<div style="flex: 0 0 6em;">Chair:</div>
											<div style="flex: 1 1 auto;">
											<i>Husheng Li</i>, University of Tennessee, USA
											</div>
										</div>
										<div style="display: flex; margin-top: 0.3em;">
											<div style="flex: 0 0 6em;">Papers:</div>
											<div style="flex: 1 1 auto;">
												<ul style="padding-left: 0">
													<li style="margin-bottom: 0.5em">
														<i>
														Shucheng Yan, Shu Cai, Wenchao Xia and Jun Zhang (Nanjing University of Posts and Telecommunications, China); Shuqiang Xia (ZTE Corporation, China),
														</i>
														<strong>A Reconfigurable Intelligent Surface Aided Dual-Function Radar and Communication System</strong>
														<div style="margin-top:0.2em"><i>(virtual presentation)</i></div>
													</li>
													<li style="margin-bottom: 0.5em">
														<i>
														Hadi Alidoustaghdam, Yang Miao and Andre Kokkeler (University of Twente, The Netherlands),
														</i>
														<strong>Integrating TDD Communication and Radar Sensing in Co-Located Planar Array: A Genetic Algorithm Enabled Aperture Design</strong>
														<div style="margin-top:0.2em"><i>(virtual presentation)</i></div>
													</li>
													<li style="margin-bottom: 0.5em">
														<i>
														Meng-Che Chang, Tuna Erdoğan, Shi-Yuan Wang and Matthieu Bloch (Georgia Institute of Technology, USA),
														</i>
														<strong>Rate and Detection Error-Exponent Tradeoffs of Joint Communication and Sensing</strong>
														<div style="margin-top:0.2em"><i>(virtual presentation)</i></div>
													</li>
													<li style="margin-bottom: 0.5em">
														<i>
														Husheng Li (University of Tennessee, USA),
														</i>
														<strong>Unified Waveform Design in Joint Communications and Sensing with Clutters: Shannon or Cramer-Rao?</strong>
														<div style="margin-top:0.3em"><i>(virtual presentation)</i></div>
													</li>
												</ul>
											</div>
										</div>
									`, ],
							[ 	`{{time("2022-03-09T10:40:00","10:40")}}<br v-if="l.showLocalTimes"> - <br v-if="l.showLocalTimes">{{time("2022-03-09T12:00:00","12:00")}}
									<br><button style="margin: 0.5em" class="btn btn-general" @click="$refs['videomodal'].openModal({title:'Paper Session II:  Localization and Sensing',time:'2022-03-09T10:40:00',name:'', affiliation: '', vimeo: '690411139?h=d52271f499'  })"><i class="fa fa-film"></i> Rewatch</button>
								`,
								`<strong>Paper Session II: Localization and Sensing (in-person session)</strong> <br>
								<div style="display: flex; margin-top: 0.3em;">
									<div style="flex: 0 0 6em;">Chair:</div>
									<div style="flex: 1 1 auto;">
									<i>Andre Bourdoux</i>, IMEC, Belgium
									</div>
								</div>
								<div style="display: flex; margin-top: 0.3em;">
									<div style="flex: 0 0 6em;">Papers:</div>
									<div style="flex: 1 1 auto;">
										<ul style="padding-left: 0">
											<li style="margin-bottom: 0.5em">
												<i>
												Hasan Can Yildirim (Université Libre de Bruxelles (ULB), Belgium); Laurent Storrer (Univesité Libre de Bruxelles (ULB), Belgium); Jerome Louveaux (Université catholique de Louvain, Belgium); Philippe De Doncker (ULB, Belgium); François Horlin (Université libre de Bruxelles, Belgium),
												</i>
												<strong>Impact of MU-MIMO on Wi-Fi Sensing: Threat or Opportunity?</strong>
												<div style="margin-top:0.2em"><i>(in-person presentation)</i></div>
											</li>
											<li style="margin-bottom: 0.5em">
												<i>
												Roberto Bomfin, Zhongju Li, Ahmad Nimr and Gerhard P. Fettweis (Technische Universität Dresden, Germany),
												</i>
												<strong>Experimental Validation of Superresolution Delay Estimation Algorithm Using a 26 GHz Radar Setup</strong>
												<div style="margin-top:0.2em"><i>(in-person presentation)</i></div>
											</li>
											<li style="margin-bottom: 0.5em">
												<i>
												Florian Roth (TU Dresden, Germany); Noémie Bidoul (UCLouvain, Belgium); Teodor Rosca (EPFL, Switzerland); Meik Dörpinghaus (TU Dresden, Germany); Denis Flandre (Université catholique de Louvain, Belgium); Mihai Adrian (EPFL, Switzerland); Gerhard P. Fettweis (Technische Universität Dresden, Germany),
												</i>
												<strong>Spike-Based Sensing and Communication for Highly Energy-Efficient Sensor Edge Nodes</strong>
												<div style="margin-top:0.2em"><i>(in-person presentation)</i></div>
											</li>
											<li style="margin-bottom: 0.5em">
												<i>
												Zhongju Li, Ahmad Nimr, Philipp Schulz and Gerhard P. Fettweis (Technische Universität Dresden, Germany),
												</i>
												<strong>Multi-Band Superresolution Multipath Channel Path Delay Estimation for CIR-Based Localization</strong>
												<div style="margin-top:0.2em"><i>(in-person presentation)</i></div>
											</li>
										</ul>
									</div>
								</div>`, ],
							[ 	`{{time("2022-03-09T12:00:00","12:00")}}<br v-if="l.showLocalTimes"> - <br v-if="l.showLocalTimes">{{time("2022-03-09T13:00:00","13:00")}}`,
								`<strong>Business Lunch</strong>`, ],
							[ 	`{{time("2022-03-09T13:00:00","13:00")}}<br v-if="l.showLocalTimes"> - <br v-if="l.showLocalTimes">{{time("2022-03-09T13:15:00","13:15")}}
									<br><button style="margin: 0.5em" class="btn btn-general" @click="$refs['videomodal'].openModal({title:'Welcome Speech from the TPC Co-Chair',time:'2022-03-09T13:00:00',name:'Dr. Fan Liu', affiliation: 'Southern University of Science and Technology, China', vimeo: '690419560?h=1e4705a12c'  })"><i class="fa fa-film"></i> Rewatch</button>
							`,
								`<strong>Welcome Speech from the TPC Co-Chair</strong>
								<br><i>Dr. Fan Liu</i>, Southern University of Science and Technology, China
								`, ],
							[ 	`{{time("2022-03-09T13:20:00","13:20")}}<br v-if="l.showLocalTimes"> - <br v-if="l.showLocalTimes">{{time("2022-03-09T14:00:00","14:00")}}
									<!--
									<br><button style="margin: 0.5em" class="btn btn-general" @click="$refs['videomodal'].openModal({title:'Keynote I: Integrated Radio-based Sensing and Communications in 5G and 6G: Prospects, Algorithms and Applications',time:'2022-03-09T13:20:00',name:'Prof. Mikko Valkama', affiliation: 'Tampere University, Finland', vimeo: '680495466'  })"><i class="fa fa-film"></i> Rewatch</button>
									-->
								`,
								`<strong>Keynote I: Integrated Radio-based Sensing and Communications in 5G and 6G: Prospects, Algorithms and Applications</strong>
									<br>Prof. Mikko Valkama
									<br><i>Tampere University, Finland</i>
									<div style="margin-top:0.2em"><i>(virtual presentation)</i></div>
								`, ],
							[ 	`{{time("2022-03-09T14:05:00","14:05")}}<br v-if="l.showLocalTimes"> - <br v-if="l.showLocalTimes">{{time("2022-03-09T14:45:00","14:45")}}
									<br><button style="margin: 0.5em" class="btn btn-general" @click="$refs['videomodal'].openModal({title:'Keynote II: Integrated Sensing and Communications: Signalling, Applications and Trade-offs',time:'2022-03-09T14:05:00',name:'Prof. Christos Masouros', affiliation: 'University College London, UK', vimeo: '690421654?h=2083f1a4d6'  })"><i class="fa fa-film"></i> Rewatch</button>
								`,
								`<strong>Keynote II: Integrated Sensing and Communications: Signalling, Applications and Trade-offs</strong>
									<br>Prof. Christos Masouros
									<br><i>University College London, UK</i>
									<div style="margin-top:0.2em"><i>(in-person presentation)</i></div>
								`, ],
							[ 	`{{time("2022-03-09T14:45:00","14:45")}}<br v-if="l.showLocalTimes"> - <br v-if="l.showLocalTimes">{{time("2022-03-09T15:00:00","15:00")}}`,
								`<strong>Coffee Break</strong>
								`, ],
							[ 	`{{time("2022-03-09T15:00:00","15:00")}}<br v-if="l.showLocalTimes"> - <br v-if="l.showLocalTimes">{{time("2022-03-09T15:30:00","15:30")}}
								<br><button style="margin: 0.5em" class="btn btn-general" @click="$refs['videomodal'].openModal({title:'Invited Talk: Applications and Challenges of Integrated Communication and Sensing in Different Vertical Domains',time:'2022-03-09T15:00:00',name:'Dr. Andreas Müller', affiliation: 'Bosch, General Chair of 5G-ACIA, Germany', vimeo: '690425423?h=f402838614'  })"><i class="fa fa-film"></i> Rewatch</button>
							`,
								`<strong>Invited Talk: Applications and Challenges of Integrated Communication and Sensing in Different Vertical Domains</strong>
									<br>Dr. Andreas Müller
									<br><i>Bosch, General Chair of 5G-ACIA, Germany</i>
								`, ],
							[ 	`{{time("2022-03-09T15:35:00","15:35")}}<br v-if="l.showLocalTimes"> - <br v-if="l.showLocalTimes">{{time("2022-03-09T16:15:00","16:15")}}
								<br><button style="margin: 0.5em" class="btn btn-general" @click="$refs['videomodal'].openModal({title:'Keynote III: Integrated Sensing and Communications: From Signal Processing to Prototypes',time:'2022-03-09T15:35:00',name:'Prof. Yonina C. Eldar', affiliation: 'Weizmann Institute of Science, Rehovot, Israel', vimeo: '690431652?h=1897c1d956'  })"><i class="fa fa-film"></i> Rewatch</button>
							`,
								`<strong>Keynote III: Integrated Sensing and Communications: From Signal Processing to Prototypes</strong>
									<br>Prof. Yonina C. Eldar
									<br><i>Weizmann Institute of Science, Rehovot, Israel</i>
								`, ],
							[ 	`{{time("2022-03-09T16:20:00","16:20")}}<br v-if="l.showLocalTimes"> - <br v-if="l.showLocalTimes">{{time("2022-03-09T17:20:00","17:20")}}
								<br><button style="margin: 0.5em" class="btn btn-general" @click="$refs['videomodal'].openModal({title:'Panel I: What Are Opportunities and Challenges of JC&S?',time:'2022-03-09T16:20:00',name:'Prof. Gerhard Fettweis, Dr. Stefan Parkvall, Dr. Thorsten Wild, Dr. Ivan Gaspar', affiliation: '', vimeo: '690437863?h=c50e5354b0'  })"><i class="fa fa-film"></i> Rewatch</button>
							`,
								`<strong>Panel I: What Are Opportunities and Challenges of JC&S?</strong>
									<br>Prof. Gerhard Fettweis, Dr. Stefan Parkvall, Dr. Thorsten Wild, Dr. Ivan Gaspar
									<div style="margin-top:0.5em"><i>(hybrid in-person/virtual panel)</i></div>
								`, ],

							[ 	`{{time("2022-03-09T19:00:00","19:00")}}<br v-if="l.showLocalTimes"> - <br v-if="l.showLocalTimes">{{time("2022-03-09T23:00:00","23:00")}}`,
								`<strong>Social Dinner</strong>
								`, ],


						]
					},
					{
						type:"html",
						value:`<h2>Thursday, March 10</h2>
						`
					},
					{
						type: "table",
						widths: ['20rem','auto'],

						// style: "",
						class: "schedule",
						id: "tblschedule",

						rowStyle: [
									"font-size: 1.3em; font-weight: bold; background-color: #8c7f9c8a; border-bottom: 1px solid gray;",
									"font-size: 1.2em; border-bottom: 1px solid rgb(193 185 201); padding-bottom: 0.3em;",
									"font-size: 1.2em; border-bottom: 1px solid rgb(193 185 201); padding-bottom: 0.3em;",
									"font-size: 1.2em; border-bottom: 1px solid rgb(193 185 201); padding-bottom: 0.3em;",
									"font-size: 1.2em; border-bottom: 1px solid rgb(193 185 201); padding-bottom: 0.3em;",
									"font-size: 1.2em; border-bottom: 1px solid rgb(193 185 201); padding-bottom: 0.3em;",
									"font-size: 1.2em; border-bottom: 1px solid rgb(193 185 201); padding-bottom: 0.3em;",
									"font-size: 1.2em; border-bottom: 1px solid rgb(193 185 201); padding-bottom: 0.3em;",
									"font-size: 1.2em; border-bottom: 1px solid rgb(193 185 201); padding-bottom: 0.3em;",
									"font-size: 1.2em; border-bottom: 1px solid rgb(193 185 201); padding-bottom: 0.3em;",
									"font-size: 1.2em; border-bottom: 1px solid rgb(193 185 201); padding-bottom: 0.3em;",
									"font-size: 1.2em; border-bottom: 1px solid rgb(193 185 201); padding-bottom: 0.3em;",
									"font-size: 1.2em; padding-bottom: 0.3em;",
								],
						colStyle: ["font-weight: bold;","text-align: left;"	],
						cellStyle: "",

						// rowClass: [],
						// colClass: [],
						// cellClass: "",

						table: [
							[	`Day 2<span v-show="!l.showLocalTimes"> (CET)</span>`,"Single Track"],
							[ 	`{{time("2022-03-10T08:30:00","8:30")}}<br v-if="l.showLocalTimes"> - <br v-if="l.showLocalTimes">{{time("2022-03-10T09:00:00","9:00")}}`,
								`<strong>Morning Coffee & Snacks</strong>
									<videomodal ref="videomodal"></videomodal>
								`, ],
							[ 	`{{time("2022-03-10T09:00:00","9:00")}}<br v-if="l.showLocalTimes"> - <br v-if="l.showLocalTimes">{{time("2022-03-10T09:40:00","9:40")}}
									<br><button style="margin: 0.5em" class="btn btn-general" @click="$refs['videomodal'].openModal({title:'Keynote IV',time:'2022-03-10T09:00:00',name:'Dr. Wen Tong', affiliation: 'Huawei Technologies Co., Ltd', vimeo: '690446766?h=7602585443'  })"><i class="fa fa-film"></i> Rewatch</button>
								`,
								`<strong>Keynote IV</strong>
								<br>Dr. Wen Tong
								<br><i>Huawei Technologies Co., Ltd</i>
								<div style="margin-top:0.2em"><i>(virtual presentation)</i></div>
								`, ],
							[ 	`{{time("2022-03-10T09:45:00","9:45")}}<br v-if="l.showLocalTimes"> - <br v-if="l.showLocalTimes">{{time("2022-03-10T10:10:15","10:15")}}
									<br><button style="margin: 0.5em" class="btn btn-general" @click="$refs['videomodal'].openModal({title:'Keynote V: Integration of Radar Sensing into Communications with Asynchronous Transceivers',time:'2022-03-10T09:45:00',name:'Prof. J. Andrew Zhang', affiliation: 'University of Technology Sydney, Australia', vimeo: '690450602?h=b44dcef541'  })"><i class="fa fa-film"></i> Rewatch</button>
								`,
								`<strong>Keynote V: Integration of Radar Sensing into Communications with Asynchronous Transceivers</strong>
								<br>Prof. J. Andrew Zhang
								<br><i>University of Technology Sydney, Australia</i>
								<div style="margin-top:0.2em"><i>(virtual presentation)</i></div>
								`, ],
							[ 	`{{time("2022-03-10T10:20:00","10:20")}}<br v-if="l.showLocalTimes"> - <br v-if="l.showLocalTimes">{{time("2022-03-10T10:50:00","10:50")}}
									<br><button style="margin: 0.5em" class="btn btn-general" @click="$refs['videomodal'].openModal({title:'Keynote VI: The Resourcefulness of Passive Radar: Techniques, Applications, and Lessons Learnt',time:'2022-03-10T10:20:00',name:'Prof. Fabiola Colone', affiliation: 'Sapienza University of Rome, Italy', vimeo: '690454031?h=ab90ab43c0'  })"><i class="fa fa-film"></i> Rewatch</button>
								`,
								`<strong>Keynote VI: The Resourcefulness of Passive Radar: Techniques, Applications, and Lessons Learnt</strong>
								<br>Prof. Fabiola Colone
								<br><i>Sapienza University of Rome, Italy</i>
								<div style="margin-top:0.2em"><i>(in-person presentation)</i></div>
								`, ],
							[ 	`{{time("2022-03-10T10:55:00","10:55")}}<br v-if="l.showLocalTimes"> - <br v-if="l.showLocalTimes">{{time("2022-03-10T12:15:00","12:15")}}
									<br><button style="margin: 0.5em" class="btn btn-general" @click="$refs['videomodal'].openModal({title:'Paper Session III: Waveform Design and Beamforming',time:'2022-03-10T10:55:00',name:'', affiliation: '', vimeo: '690537770?h=50456b793d'  })"><i class="fa fa-film"></i> Rewatch</button>
								`,
								`<strong>Paper Session III: Waveform Design and Beamforming (hybrid session)</strong> <br>
								<div style="display: flex; margin-top: 0.3em;">
									<div style="flex: 0 0 6em;">Chair:</div>
									<div style="flex: 1 1 auto;">
									<i>André Noll Barreto</i>, Barkhausen Institut, Dresden, Germany
									</div>
								</div>
								<div style="display: flex; margin-top: 0.3em;">
									<div style="flex: 0 0 6em;">Papers:</div>
									<div style="flex: 1 1 auto;">
										<ul style="padding-left: 0">
											<li style="margin-bottom: 0.5em">
												<i>
												Qi Wang (Huawei Technologies Duesseldorf GmbH, Germany); Anastasios Kakkavas (Munich Research Center, Huawei Technologies Duesseldorf GmbH & Technische Universität München, Germany); Xitao Gong (Huawei Technologies Duesseldorf GmbH, Germany); Richard A. Stirling-Gallacher (Munich Research Center, Huawei Technologies Duesseldorf GmbH, Germany),
												</i>
												<strong>Towards Integrated Sensing and Communications for 6G</strong>
												<div style="margin-top:0.2em"><i>(in-person presentation)</i></div>
											</li>
											<li style="margin-bottom: 0.5em">
												<i>
												Husheng Li (University of Tennessee, USA),
												</i>
												<strong>Trade-Off in Joint Communications and Sensing with Frequency Modulation Waveforms</strong>
												<div style="margin-top:0.2em"><i>(virtual presentation)</i></div>
											</li>
											<li style="margin-bottom: 0.5em">
												<i>
												Tong Wei (Interdisciplinary Centre for Security, Reliability and Trust (SnT) & University of Luxembourg, Luxembourg); Linlong Wu (University of Luxembourg, Luxembourg); Kumar Vijay Mishra (United States Army Research Laboratory, USA); Bhavani Shankar Mysore R (Interdisciplinary Centre for Security, Reliability and Trust & University of Luxembourg, Luxembourg),
												</i>
												<strong>Multiple IRS-Assisted Wideband Dual-Function Radar-Communication</strong>
												<div style="margin-top:0.2em"><i>(in-person presentation)</i></div>
											</li>
											<li style="margin-bottom: 0.5em">
												<i>
												Sayed Hossein Dokhanchi (Barkhausen Institut, Germany); Andre N Barreto (Barkhausen Institut gGmbH, Germany & Universidade de Brasilia, Brazil); Gerhard Fettweis (Barkhausen Institut, Germany),
												</i>
												<strong>A Half-Duplex Joint Communications and Sensing System Using ZP-OFDM</strong>
												<div style="margin-top:0.2em"><i>(in-person presentation)</i></div>
											</li>

										</ul>
									</div>
								</div>
								`, ],
							[ 	`{{time("2022-03-10T12:15:00","12:15")}}<br v-if="l.showLocalTimes"> - <br v-if="l.showLocalTimes">{{time("2022-03-10T13:00:00","13:00")}}`,
								`<strong>Business Lunch</strong>
								`, ],
							[ 	`{{time("2022-03-10T13:00:00","13:00")}}<br v-if="l.showLocalTimes"> - <br v-if="l.showLocalTimes">{{time("2022-03-10T13:40:00","13:40")}}
									<br><button style="margin: 0.5em" class="btn btn-general" @click="$refs['videomodal'].openModal({title:'Keynote VII: Multipath Assisted Positioning and Sensing – What the Mobile Radio Channel Tells Us About the Environment',time:'2022-03-10T13:00:00',name:'Dr. Armin Dammann', affiliation: 'German Aerospace Center (DLR)', vimeo: '690460968?h=d2752e0778'  })"><i class="fa fa-film"></i> Rewatch</button>
								`,
								`<strong>Keynote VII: Multipath Assisted Positioning and Sensing – What the Mobile Radio Channel Tells Us About the Environment</strong>
								<br>Dr. Armin Dammann
								<br><i>German Aerospace Center (DLR)</i>
								<div style="margin-top:0.2em"><i>(in-person presentation)</i></div>
								`, ],
							[ 	`{{time("2022-03-10T13:45:00","13:45")}}<br v-if="l.showLocalTimes"> - <br v-if="l.showLocalTimes">{{time("2022-03-10T14:45:00","14:45")}}
									<br><button style="margin: 0.5em" class="btn btn-general" @click="$refs['videomodal'].openModal({title:'Panel II: Will Joint Communication and Sensing (JC&S) Become the Killer Feature of 6G?',time:'2022-03-10T13:45:00',name:'Dr. Andreas Mueller, Prof. Giuseppe Caire, Prof. Zhiyong Feng, Prof. Taneli Riihonen', affiliation: '', vimeo: '690465903?h=9285de5b23'  })"><i class="fa fa-film"></i> Rewatch</button>
								`,
								`<strong>Panel II: Will Joint Communication and Sensing (JC&S) Become the Killer Feature of 6G?</strong>
								<br>Dr. Andreas Mueller, Prof. Giuseppe Caire, Prof. Zhiyong Feng, Prof. Taneli Riihonen
								<div style="margin-top:0.5em"><i>(virtual panel)</i></div>
								`, ],
							[ 	`{{time("2022-03-10T14:45:00","14:45")}}<br v-if="l.showLocalTimes"> - <br v-if="l.showLocalTimes">{{time("2022-03-10T14:55:00","14:55")}}`,
								`<strong>Coffee Break</strong>
								`, ],
							[ 	`{{time("2022-03-10T15:00:00","15:00")}}<br v-if="l.showLocalTimes"> - <br v-if="l.showLocalTimes">{{time("2022-03-10T16:25:00","16:25")}}
									<br><button style="margin: 0.5em" class="btn btn-general" @click="$refs['videomodal'].openModal({title:'Paper Session IV: Channel and Propagation',time:'2022-03-10T15:00:00',name:'', affiliation: '', vimeo: '690469708?h=29b92a70bd'  })"><i class="fa fa-film"></i> Rewatch</button>
								`,
								`<strong>Paper Session IV: Channel and Propagation (virtual session)</strong> <br>
								<div style="display: flex; margin-top: 0.3em;">
									<div style="flex: 0 0 6em;">Chair:</div>
									<div style="flex: 1 1 auto;">
									<i>Li Chen</i>, University of Science and Technology of China, China
									</div>
								</div>
								<div style="display: flex; margin-top: 0.3em;">
									<div style="flex: 0 0 6em;">Papers:</div>
									<div style="flex: 1 1 auto;">
										<ul style="padding-left: 0">
											<li style="margin-bottom: 0.5em">
												<i>
												Zhibo Yang (University of Science and Technology of China, China); Chen Li (University of Science And Technology of China, China); Weidong Wang (University of Science and Technology of China, China),
												</i>
												<strong>Location and Attitude Information Aided Codeword Selection in Millimeter Wave MIMO System</strong>
												<div style="margin-top:0.2em"><i>(virtual presentation)</i></div>
											</li>
											<li style="margin-bottom: 0.5em">
												<i>
												Maximilian Arnold (Nokia Stuttgart, Germany); Maximilian Bauhofer (University of Stuttgart, Germany); Silvio Mandelli (Nokia Bell Labs, Germany); Marcus Henninger (University of Stuttgart & Nokia Bell Labs, Germany); Frank Schaich and Thorsten Wild (Nokia Bell Labs, Germany); Stephan ten Brink (University of Stuttgart, Germany),
												</i>
												<strong>MaxRay: A Raytracing-Based Integrated Sensing and Communication Framework</strong>
												<div style="margin-top:0.2em"><i>(virtual presentation)</i></div>
											</li>
											<li style="margin-bottom: 0.5em">
												<i>
												Laurent Storrer (Univesité Libre de Bruxelles (ULB), Belgium); Hasan Can Yildirim (Université Libre de Bruxelles (ULB), Belgium); Jerome Louveaux (Université catholique de Louvain, Belgium); Philippe De Doncker (ULB, Belgium); Sofie Pollin (KU Leuven, Belgium); François Horlin (Université libre de Bruxelles, Belgium),
												</i>
												<strong>Impact of Inter-Body Scattering on People Counting with Wi-Fi Sensing</strong>
												<div style="margin-top:0.2em"><i>(virtual presentation)</i></div>
											</li>
											<li style="margin-bottom: 0.5em">
												<i>
												Paul Schwarzbach (TU Dresden, Germany); Jonas Ninnemann (Technische Universität Dresden, Germany); Oliver Michler (Dresden University of Technology, Germany),
												</i>
												<strong>Enabling Radio Sensing for Multimodal Intelligent Transportation Systems: From Virtual Testing to Immersive Testbeds</strong>
												<div style="margin-top:0.2em"><i>(virtual presentation)</i></div>
											</li>

										</ul>
									</div>
								</div>
								`, ],
							[ 	`{{time("2022-03-10T16:30:00","16:30")}}<br v-if="l.showLocalTimes"> - <br v-if="l.showLocalTimes">{{time("2022-03-10T17:50:00","17:50")}}
									<br><button style="margin: 0.5em" class="btn btn-general" @click="$refs['videomodal'].openModal({title:'Paper Session V: Hardware Reuse and Optimization',time:'2022-03-10T16:30:00',name:'', affiliation: '', vimeo: '690473802?h=a95adcb357'  })"><i class="fa fa-film"></i> Rewatch</button>
								`,
								`<strong>Paper Session V: Hardware Reuse and Optimization (virtual session)</strong><br>
								<div style="display: flex; margin-top: 0.3em;">
									<div style="flex: 0 0 6em;">Chair:</div>
									<div style="flex: 1 1 auto;">
									<i>Fan Liu</i>, Southern University of Science and Technology, China
									</div>
								</div>
								<div style="display: flex; margin-top: 0.3em;">
									<div style="flex: 0 0 6em;">Papers:</div>
									<div style="flex: 1 1 auto;">
										<ul style="padding-left: 0">
											<li style="margin-bottom: 0.5em">
												<i>
												Fangzhan Shi and Wenda Li (University College London, United Kingdom (Great Britain)); Amin Amiri (UCL, United Kingdom (Great Britain)); Shelly Vishwakarma, Chong Tang, Paul Brennan and Kevin Chetty (University College London, United Kingdom (Great Britain)),
												</i>
												<strong>Pi-NIC: Indoor Sensing Using Synchronized Off-The-Shelf Wireless Network Interface Cards and Raspberry Pis </strong>
												<div style="margin-top:0.2em"><i>(virtual presentation)</i></div>
											</li>
											<li style="margin-bottom: 0.5em">
												<i>
												Aryan Kaushik (University of Sussex, United Kingdom (Great Britain)); Aakash Arora (SnT, University of Luxembourg, Luxembourg); Christos G. Tsinos (University of Luxembourg, Luxembourg); Christos Masouros (University College London, United Kingdom (Great Britain)); Fan Liu (Southern University of Science and Technology, China); Symeon Chatzinotas (University of Luxembourg, Luxembourg),
												</i>
												<strong>Waveform Design for Joint Radar-Communications with Low Complexity Analog Components</strong>
												<div style="margin-top:0.2em"><i>(virtual presentation)</i></div>
											</li>
											<li style="margin-bottom: 0.5em">
												<i>
												Ali Behravan (Ericsson, Sweden); Robert Baldemair (Ericsson AB & Ericsson Research, Sweden); Stefan Parkvall (Ericsson Research, Sweden); Vijaya Parampalli Yajnanarayana (Ericsson Research, India); Erik Dahlman and Deep Shrestha (Ericsson Research, Sweden),
												</i>
												<strong>Introducing Sensing into Future Wireless Communication Systems</strong>
												<div style="margin-top:0.2em"><i>(virtual presentation)</i></div>
											</li>
											<li style="margin-bottom: 0.5em">
												<i>
												Adham Sakhnini (Imec, Belgium); Sibren De Bast (KU Leuven, Belgium); Mamoun Guenach (Imec, Leuven, Belgium); Andre Bourdoux (IMEC, Belgium); Hichem Sahli (Vrije Universiteit Brussel, Belgium); Sofie Pollin (KU Leuven, Belgium),
												</i>
												<strong>An Experimental Evaluation of Robust Near-Field Radar Localization Using a Massive MIMO Testbed</strong>
												<div style="margin-top:0.2em"><i>(virtual presentation)</i></div>
											</li>

										</ul>
									</div>
								</div>
								`, ],
							[ 	`{{time("2022-03-10T17:55:00","17:55")}}<br v-if="l.showLocalTimes"> - <br v-if="l.showLocalTimes">{{time("2022-03-10T18:00:00","18:00")}}
									<br><button style="margin: 0.5em" class="btn btn-general" @click="$refs['videomodal'].openModal({title:'Conference Closing Speech',time:'2022-03-10T17:55:00',name:'', affiliation: '', vimeo: '690477081?h=a8b6bc3cdf'  })"><i class="fa fa-film"></i> Rewatch</button>
								`,
								`<strong>Conference Closing Speech</strong>
								`, ],
						]
					}

				]
		},

		{
			name: "venue",
			title: "Venue",
			background: "venue",
			content: [
				{
					type: "html",
					value: `
						<div style="font-size: 1.3em">
						<p><strong>Location: Seefeld in Tirol, Austria</strong></p>
						<p><strong>Venue: <a href="https://www.seefeld-sports.at/en/olympia-sport-und-kongresszentrum/ol" target="_blank">Congress Center Seefeld</a> </strong> </p>
						<p>Accommodations close to the congress center can be found <a href="https://www.seefeld.com/en/hotel-tyrol/congress-seminar">here</a>.</p>
						</div>
					`
				}
			]
		},

		{
			name: "authors",
			background: "dark",
			title: "Authors",
			till: "2022-03-07T08:00:00",
			content: [
				{
					type: "html",
					value: `

					<a class="btn btn-outline" href="" @click.prevent="showCfP()">View Call for Papers</a>
		 			<br>
		 			<a class="btn btn-outline" href="" @click.prevent="showCRInstructions()">Instructions for Final Manuscript</a>

		 			<h2 style="margin-top: 1em">Deadlines</h2>

					<div style="font-size: 1.4em;margin-top: 1.5em;margin-bottom: 1em;line-height: 1.8em;">
						<div style="opacity: 0.5;">
							<strong>Paper Submission:</strong>
							<span style="display: inline-block; margin-left: 1em;">
								Nov 26, 2021
							</span>
						</div>
						<div style="opacity: 0.5">
							<strong>Acceptance Notification:</strong>
							<span style="display: inline-block; margin-left: 1em;  text-decoration: line-through; margin-right: 1em;">
								Dec 23, 2021
							</span>
							Jan 3, 2022
						</div>
						<div style="opacity: 1">
							<strong>Video Submission</strong>:
							<span style="display: inline-block; margin-left: 1em;">
								Jan 24, 2022
							</span>
						</div>
						<div style="opacity: 1">
							<strong>Final Paper:</strong>
							<span style="display: inline-block; margin-left: 1em;">
								Jan 24, 2022
							</span>
						</div>
					</div>
					<a href="video-guidelines" style="font-size: 1.8em; font-weight: bold;">>> Video Production Guidelines <<</a>
					`

				},

			]
		},

		{
			name: "registration",
			title: "Registration",
			till: "2022-03-10T17:30:00",
			content: [

				{
					type: "html",
					value: `
						<p style="margin-top: -0em; font-size: 1.5em;">Registration is still available. Please register <a style="font-weight: bold" href="https://react.regasus.de/portal/init?mnemonic=JCnS2022" target="_blank">&gt;&gt;&nbsp;here&nbsp;&lt;&lt;</a>&nbsp;.</p>
					`
				},
				{
					type: "html",
					value: `<h2>Prices:</h2>`
				},
				{
					type: "html",
					value: `
					<h3 style="margin-top: 0em">Physical Attendance</h3>
					<label class="check-label"><input type="checkbox" v-model="l.includeVat">Include VAT in prices</label>
					<div style="margin-bottom: -1em"></div>
					`
				},
				{
					type: "table",
					widths: ["10em",'auto','auto','auto','auto'],
						rowStyle: ["font-weight: bold; border-bottom: 1px solid gray; background-color: #c1b9c9"],
						colStyle: ["font-weight: bold;"],
						cellStyle: "font-size: 1.2em;",

						// 		// rowClass: [],
						// 		// colClass: [],
						// 		// cellClass: "",
						table: [
							[ ``, "Non IEEE Member", "IEEE Member", "IEEE ComSoc Member", "IEEE Life Member"],
							[ "Author", '{{getPrice(750,20)}} €', '{{getPrice(675,20)}} €', '{{getPrice(650,20)}} €', '{{getPrice(625,20)}} €'],
							[ "Attendee (full)", '{{getPrice(500,20)}} €', '{{getPrice(470,20)}} €', '{{getPrice(440,20)}} €', '{{getPrice(360,20)}} €'],
							[ "Attendee (student)", '{{getPrice(250,20)}} €', '{{getPrice(230,20)}} €', '{{getPrice(210,20)}} €', "-"],
							[ "Sponsor / Invited Speaker", "-", "-", "-", "-"],
						]
				},
				{
					type: "html",
					value: `
					<p>Prices <span v-show="!l.includeVat">excluding 20% VAT that apply additionally</span><span v-show="l.includeVat">including 20% VAT</span>.</p>
					<p>Each paper must be covered by one author registration.</p>
					`
				},
				{
					type: "html",
					value: `
					<h3 style="margin-top: 0em">Virtual Attendance</h3>
					<label class="check-label"><input type="checkbox" v-model="l.includeVat">Include VAT in prices</label>
					<div style="margin-bottom: -1em"></div>
					`
				},
				{
					type: "table",
					widths: ["10em",'auto','auto','auto','auto'],
						rowStyle: ["font-weight: bold; border-bottom: 1px solid gray; background-color: #c1b9c9"],
						colStyle: ["font-weight: bold;"],
						cellStyle: "font-size: 1.2em;",

						// 		// rowClass: [],
						// 		// colClass: [],
						// 		// cellClass: "",
						table: [
							[ ``, "Non IEEE Member", "IEEE Member", "IEEE ComSoc Member", "IEEE Life Member"],
							[ "Author", '{{getPrice(375,20)}} €', '{{getPrice(300,20)}} €', '{{getPrice(275,20)}} €', '{{getPrice(250,20)}} €'],
							[ "Attendee (full)", '{{getPrice(160,20)}} €', '{{getPrice(130,20)}} €', '{{getPrice(100,20)}} €', '{{getPrice(20,20)}} €'],
							[ "Attendee (student)", '{{getPrice(60,20)}} €', '{{getPrice(40,20)}} €', '{{getPrice(20,20)}} €', "-"],
							[ "Sponsor / Invited Speaker", "-", "-", "-", "-"],
						]
				},
				{
					type: "html",
					value: `
					<p>Prices <span v-show="!l.includeVat">excluding 20% VAT that apply additionally</span><span v-show="l.includeVat">including 20% VAT</span>.</p>
					<p>Each paper must be covered by one author registration.</p>
					`
				}
			]
		},

		{
			name: "committee",
			title: "Committee",
			background: "dark",
			content: [
				{
					type: "component:organizers"
				}
			]
		},

	],

	cfp: cfp,
	cameraReadyInstructions: `
		<p>If you have received a paper acceptance email from the TPC co-chairs, please use these author instructions to prepare your final camera-ready paper.</p>
		<p>Formatting checks are enforced in the submission phase for final manuscripts. Please allow extra time to fix any formatting errors and use PDF-eXpress to generate a compliant file.</p>
		<h3>Copyright</h3>
		<p>Authors must sign their copyright form via IEEE eCopyright service. Please login to your EDAS account and look for your accepted paper(s) under your EDAS dashboard, then click to add a “copyright form”. You will be then redirected to an EDAS webpage in which you should click on the button “IEEE Copyright Submission”. Next, you will be redirected to IEEE eCF website where you just need to follow the wizard to complete, sign and submit your copyright form online.</p>
		<p>The appropriate copyright clearance code notice is to appear on the bottom of the first page of each paper per the guidelines set forth in the Cataloging / Copyright Instructions for an IEEE Conference Proceeding. Detailed instructions can be found at: <a href="http://www.ieee.org/publications_standards/publications/rights/index.html" target="_blank">http://www.ieee.org/publications_standards/publications/rights/index.html</a></p>
		<ul>
		 <li>For papers in which all authors are employed by the US government, the copyright notice is: <strong style="color:red">U.S. Government work not protected by U.S. copyright</strong></li>
		 <li>For papers in which all authors are employed by a Crown government (UK, Canada, and Australia), the copyright notice is: <strong style="color:red">978-1-6654-0579-9/22/$31.00 ©2022 Crown</strong></li>
		 <li>For papers in which all authors are employed by the European Union, the copyright notice is: <strong style="color:red">978-1-6654-0579-9/22/$31.00 ©2022 European Union</strong></li>
		 <li>For all other papers the copyright notice is: <strong style="color:red">978-1-6654-0579-9/22/$31.00 ©2022 IEEE</strong></li>
		</ul>
		<p><strong>Latex users</strong>can add following lines just before <code>begin{document}</code> for the copyright notice to show up (shown below as an example for the fourth case above):</p>
<pre>\\IEEEoverridecommandlockouts
\\IEEEpubid{\\makebox[\\columnwidth]{978-1-6654-0579-9/22/\\$31.00~\\copyright{}2022 IEEE \\hfill} \\hspace{\\columnsep}\\makebox[\\columnwidth]{ }}</pre>
		<p>MS Word users can use <i>Insert</i> → <i>Text Box</i>, to insert the appropriate copyright notice in the texbox, and place the box (without border) at the bottom left of the first page.</p>
		<h3>IEEE PDF eXpress</h3>
		<ul>
		 <li>Go to <a href="http://ieee-pdf-express.org/" target="_blank">IEEE PDF eXpress Website</a>.</li>
		 <li>Create an IEEE PDF eXpress account (use conference ID: <strong style="color: red">54387X</strong>)</li>
		 <li>Use ‘new user’ if you haven’t used this site before.</li>
		</ul>
		<p>Use IEEE PDF eXpress to check if your PDF file is Xplore-compliant, OR, else, you can use this site to convert your source files into an IEEE Xplore-compliant PDF file (e.g., for LaTeX users, create a zip file that includes dvi and your eps figure files all together, and then upload the zip file for the system to convert into a compliant PDF file; for MSWord users, upload the Word file and let it convert and return a compliant PDF file).</p>

		<h3>Camera-Ready Paper Upload to EDAS</h3>
		<ul>
		  <li>Log into <a href="https://edas.info/" target="_blank">EDAS</a> and upload the following at your paper entry page: Camera-ready copy of your paper that must be PDF eXpress compliant.</li>
		</ul>

		<p>In order to be published in the Proceedings of the 2nd IEEE Symposium on Joint Communications & Sensing and to be submitted for inclusion in IEEE Xplore®, an author of an accepted paper is required to register for the conference at the full rate and the paper must be presented at the conference.</p>

		<p><strong>One full author registration is valid for one paper</strong>.

		<p><strong>If you have any questions on creating and/or submitting the camera-ready paper, please contact the publication chairs or the TPC co-chairs:</strong></p>
		<ul>
		  <li><a href="mailto:Andre.Nollbarreto@barkhauseninstitut.org">André Noll Barreto</a>, Barkhausen Institut</li>
		  <li><a href="mailto:Andre.Bourdoux@imec.be">André Bourdoux</a>, IMEC, Belgium</li>
		  <li><a href="mailto:liuf6@sustech.edu.cn">Fan Liu</a>, SUS Tech, China</li>
		</ul>
	`

};
